export const createLocalId = (): string => {
	return crypto.randomUUID();
};
